// HST — Bloc prêt à brancher dans pages/Depot.jsx (DepotDetailView) :
//   <DepotHST depotId={depot.id} />
// Remplace DepotScene + DepotRoadmap + DepotTimeline + DepotUpgradeTree.

import React, { useMemo, useState } from 'react';
import { useShallow } from 'zustand/react/shallow';
import useGameStore from '../../store/gameStore';
import { useTranslation } from '../../i18n';
import DepotVue3D from './DepotVue3D';
import FriseChronologique from './FriseChronologique';
import ArbreDeveloppement from './ArbreDeveloppement';
import { toDepot3D, buildDepotTree, buildFor } from './adaptateurHST';

export default function DepotHST({ depotId }) {
  // uniquement les tranches d'état utiles à la vue (évite les re-rendus inutiles)
  const s = useGameStore(useShallow((st) => ({
    ownedDepots: st.ownedDepots, activeInvestments: st.activeInvestments, investmentPurchaseDays: st.investmentPurchaseDays,
    vehicles: st.vehicles, drivers: st.drivers, activeContracts: st.activeContracts, treasury: st.treasury,
    totalDays: st.totalDays, company: st.company, hiredDepotManagers: st.hiredDepotManagers, hiredSupport: st.hiredSupport,
    monthlyRevenues: st.monthlyRevenues, monthlyHistory: st.monthlyHistory, phase: st.phase, reputation: st.reputation,
  })));
  // 21/10/2026 — arbre et dépôt recalculés quand la langue de l'UI change.
  const { language } = useTranslation();
  const tree = useMemo(() => buildDepotTree(language), [language]);
  const depot = useMemo(() => toDepot3D({ ...useGameStore.getState(), ...s }, depotId), [s, depotId, language]); // eslint-disable-line react-hooks/exhaustive-deps
  const [selection, setSelection] = useState(undefined);
  if (!depot) return null;
  const pick = (id) => setSelection({ type: 'zone', id });
  const onBuild = (zoneId) => buildFor(useGameStore.getState(), depotId, zoneId);

  return (
    <div className="space-y-4" data-testid="depot-hst-3d">
      <DepotVue3D depot={depot} tree={tree} onBuild={onBuild} onSelect={setSelection} selection={selection} />
      <FriseChronologique depot={depot} tree={tree} onPick={pick} />
      <ArbreDeveloppement depot={depot} tree={tree} selectedId={selection?.type === 'zone' ? selection.id : null} onPick={pick} />
    </div>
  );
}
